import styled from "styled-components";
import { themeTypes } from "../../../shared/styled/Theme";

export const StyledMatchBroadcaster = styled.div`
  font-family: ${(props) => props.theme.figma.base.fontfamily_mlstifo_standard};
  font-weight: 500;
  color: rgba(0, 0, 0, 0.4);
  font-size: ${(props) => props.theme.mixins.pxToRem(11)};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: flex;
  justify-content: center;
  position: relative;
  color: ${(props) =>
    props.theme.type === themeTypes.light
      ? props.theme.rgba.black_100_60
      : props.theme.rgba.white_100_60};
`;
export const StyledMatchBroadcasterApple = styled.span`
  // + span {
  //   margin-left: -2px;
  // }
  svg {
    fill: ${(props) => (props.isLive ? "#000" : "auto")};
  }
`;

export const StyledMatchBroadcasterLabel = styled.span`
  display: flex;
  height: 15px;

  svg {
    fill: ${(props) => props.theme.rgba.white_178};
  }
`;

export const StyledMatchBroadcasterStringifiedWrapper = styled.div`
  position: absolute;
  left: 0;
  width: 100%;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  color: ${(props) =>
    props.theme.type === themeTypes.light
      ? props.theme.rgba.black_100_60
      : props.theme.rgba.white_100_60};
`;

export const StyledMatchBroadcasterStringified = styled.span`
  font-size: ${(props) => props.theme.mixins.pxToRem(10)};
`;

export const StyledPipe = styled.span`
  display: inline-block;
  border-right: 1.6px solid
    ${(props) =>
      props.theme.type === themeTypes.light
        ? "rgba(0, 0, 0, 0.3)"
        : "rgba(255, 255, 255, 0.3)"};
  margin: 0 4px;
  height: 15px;
`;

export const StyledMatchBroadcasterAppleWrapper = styled.div``;
